import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg"
import { ReactComponent as ShowIcon } from "assets/icons/show.svg"
import { ReactComponent as UnreadIcon } from "assets/icons/unread.svg"
import { ReactComponent as MuteIcon } from "assets/icons/mute-notification.svg"

import { ReactComponent as DropdownMenuIcon } from "assets/icons/dropdown-menu.svg"

import { BaseNotification, Divider, DropdownItem } from "./styles"
import styles from "./styles.module.scss"
import userAvatar from "assets/user.jpg"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { forwardRef, useMemo } from "react"
import {
  INotification,
  useDeleteNotification,
  useMarkAsRead,
  useMarkAsUnread,
  useEditConfiguration,
} from "./queries"
import truncate from "utils/truncate-string"
import { Avatar, Dropdown, MenuProps } from "antd"
import moment from "moment"
import i18next from "i18next"

const Notification = forwardRef<any, INotification>(
  (
    { id, avatar, creator, subject, time, module, viewed, details, type, link },
    ref
  ) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { mutate: markAsRead } = useMarkAsRead()
    const { mutate: markAsUnread } = useMarkAsUnread()
    const { mutate: deleteNotification } = useDeleteNotification()
    const { mutate: muteNotification } = useEditConfiguration()

    const timeDistance = useMemo(() => {
      moment.locale(i18next.language)
      return moment(time).fromNow()
    }, [i18next.language])

    const items: MenuProps["items"] = [
      {
        key: "1",
        label: (
          <DropdownItem>
            <ShowIcon />
            {t("global.view")}
          </DropdownItem>
        ),
        onClick: () => {
          !viewed && markAsRead(id)
          navigate(link)
        },
      },
      {
        key: "2",
        label: (
          <DropdownItem>
            <UnreadIcon />
            {viewed
              ? t("notifications.mark_unread")
              : t("notifications.mark_read")}
          </DropdownItem>
        ),
        onClick: () => {
          viewed ? markAsUnread(id) : markAsRead(id)
        },
      },
      {
        key: "4",
        label: (
          <DropdownItem>
            <MuteIcon />
            {t("notifications.mute")}
          </DropdownItem>
        ),
        onClick: () => {
          muteNotification({ type })
        },
      },
      {
        key: "3",
        label: (
          <DropdownItem>
            <DeleteIcon />
            {t("global.delete")}
          </DropdownItem>
        ),
        onClick: () => {
          deleteNotification(id)
        },
      },
    ]

    return (
      <>
        <BaseNotification
          ref={ref}
          onDoubleClick={() => {
            !viewed && markAsRead(id)
            navigate(link)
          }}
          viewed={viewed}
        >
          <Avatar className={styles.avatar} src={avatar ?? userAvatar} />{" "}
          <div>
            <span className={styles.notificationHeader}>
              <p className="body-heavy">{creator?.name}</p>
              <p className="body">{truncate(subject || "", 30)}</p>
            </span>
            <span>
              <p className="caption">{timeDistance}</p>
              <p className="caption">| {module}</p>
            </span>
            <span>
              <p>{details}</p>
            </span>
          </div>
          <div>
            <Dropdown
              menu={{ items }}
              placement="bottomRight"
              arrow={{ pointAtCenter: true }}
              trigger={["click"]}
            >

              <div className={styles.dropdownMenuIcon}>
                <DropdownMenuIcon />
              </div>

            </Dropdown>
          </div>
        </BaseNotification>
        <Divider />
      </>
    )
  }
)

export default Notification
